var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58333 15.2082H16.25C16.595 15.2082 16.875 14.9282 16.875 14.5832V2.49984C16.875 2.11317 16.7217 1.74234 16.4475 1.469C16.1742 1.19484 15.8033 1.0415 15.4167 1.0415C13.3808 1.0415 8.12417 1.0415 5.41667 1.0415C4.80917 1.0415 4.22583 1.28317 3.79583 1.71234C3.36667 2.14234 3.125 2.72567 3.125 3.33317V16.2498C3.125 16.5948 3.405 16.8748 3.75 16.8748C4.095 16.8748 4.375 16.5948 4.375 16.2498C4.375 16.2498 4.375 7.15984 4.375 3.33317C4.375 3.0565 4.485 2.79234 4.68 2.5965C4.87583 2.4015 5.14 2.2915 5.41667 2.2915H15.4167C15.4717 2.2915 15.525 2.31317 15.5642 2.35234C15.6033 2.3915 15.625 2.44484 15.625 2.49984V13.9582H9.58333C9.23833 13.9582 8.95833 14.2382 8.95833 14.5832C8.95833 14.9282 9.23833 15.2082 9.58333 15.2082Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58333 13.958H5.625C4.24417 13.958 3.125 15.0772 3.125 16.458C3.125 17.1213 3.38833 17.7572 3.8575 18.2255C4.32583 18.6947 4.96167 18.958 5.625 18.958H15.4167C15.8033 18.958 16.1742 18.8047 16.4475 18.5305C16.7217 18.2572 16.875 17.8863 16.875 17.4997C16.875 16.9197 16.875 16.2497 16.875 16.2497C16.875 15.9047 16.595 15.6247 16.25 15.6247C15.905 15.6247 15.625 15.9047 15.625 16.2497V17.4997C15.625 17.5547 15.6033 17.608 15.5642 17.6472C15.525 17.6863 15.4717 17.708 15.4167 17.708H5.625C5.29333 17.708 4.97583 17.5763 4.74083 17.3422C4.50667 17.1072 4.375 16.7897 4.375 16.458C4.375 15.768 4.935 15.208 5.625 15.208H9.58333C9.92833 15.208 10.2083 14.928 10.2083 14.583C10.2083 14.238 9.92833 13.958 9.58333 13.958Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08325 5.625H12.9166C13.2616 5.625 13.5416 5.345 13.5416 5C13.5416 4.655 13.2616 4.375 12.9166 4.375H7.08325C6.73825 4.375 6.45825 4.655 6.45825 5C6.45825 5.345 6.73825 5.625 7.08325 5.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.96b4b7467d62d5b6e44c31219c1c810c.svg";
export { ForwardRef as ReactComponent };